import React from 'react';
import './mapgrid.css';

function MapGrid({ area, mapInfo, position }) {
    return (
        <div>
            <div className="map-grid">
                {mapInfo.map((item, index) => {
                    const color = item.color || item;
                    const exits = item.exits || [];
                    const hasUp = exits.includes('u');
                    const hasDown = exits.includes('d');
                    
                    return (
                        <div 
                            key={index} 
                            className='map-grid-item' 
                            style={{ 
                                backgroundColor: color !== '5,5,5' ? `rgba(${color})` : 'rgba(0,0,0,0.35)',
                                borderTop: !exits.includes('n') ? '2px solid var(--map-grid-outline)' : '1px solid rgba(0,0,0,0.2)',
                                borderBottom: !exits.includes('s') ? '2px solid var(--map-grid-outline)' : '1px solid rgba(0,0,0,0.2)',
                                borderRight: !exits.includes('e') ? '2px solid var(--map-grid-outline)' : '1px solid rgba(0,0,0,0.2)',
                                borderLeft: !exits.includes('w') ? '2px solid var(--map-grid-outline)' : '1px solid rgba(0,0,0,0.2)',
                                position: 'relative',
                            }}
                        >
                            {(hasUp || hasDown) && (
                                <span className="exit-arrows">
                                    {hasUp && '↑'}
                                    {hasDown && '↓'}
                                </span>
                            )}
                        </div>
                    );
                })}
                <div className='dot' style={{ gridColumn: position[0], gridRow: position[1] }}>
                    <span className="material-symbols-outlined">
                        accessibility_new
                    </span>
                </div>
            </div>
            <div className='map-title'>{area}</div>
        </div>
    );
}

export default MapGrid;